import { render, staticRenderFns } from "./attr-item.vue?vue&type=template&id=c9f98126&scoped=true"
import script from "./attr-item.vue?vue&type=script&lang=js"
export * from "./attr-item.vue?vue&type=script&lang=js"
import style0 from "./attr-item.vue?vue&type=style&index=0&id=c9f98126&prod&lang=scss&scoped=true"
import style1 from "./attr-item.vue?vue&type=style&index=1&id=c9f98126&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f98126",
  null
  
)

export default component.exports